/**
 * Created by m.igrachev on 8/4/2017.
 */
//Input: "asd $1$ sdf $2$ $3$ gergdf $4$ ", ["$1$", "$2$", "$3$", "$4$"]
//Output: ["asd ", "$1$", " sdf ", "$2$", " ", "$3$", " gergdf ", "$4$", " "]
export default function splitWithPlaceholders(text, placeholders) {
    let content = [text];
    placeholders.forEach(placeholder => {
        while (findOccurrence(content, placeholder) !== false) {
            let occurrenceIndex = findOccurrence(content, placeholder);
            let contentItem = content[occurrenceIndex];
            content.splice(occurrenceIndex, 1);
            let contentItemSplit = contentItem.split(placeholder);
            let placeholdersCount = contentItemSplit.length - 1;
            for (let j = contentItemSplit.length - 1; j >= 0; j--) {
                if (contentItemSplit[j] !== "") {
                    content.splice(occurrenceIndex, 0, contentItemSplit[j]);
                }
                if (placeholdersCount) {
                    placeholdersCount--;
                    content.splice(occurrenceIndex, 0, placeholder);
                }
            }
        }
    });
    return content;
}

function findOccurrence(array, item) {
    for (let i = 0; i < array.length; i++) {
        let arrayItem = array[i];
        if (arrayItem.includes(item) && arrayItem !== item) {
            return i;
        }
    }

    return false;
}
